module.exports = __webpack_public_path__ + "img/16.ab988ce6.jpg";